import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import Commodity from '@/components/Commodity'
import Commodity01 from '@/components/commodity/Commodity01'
import Commodity02 from '@/components/commodity/Commodity02'
import Commodity03 from '@/components/commodity/Commodity03'
import Commodity04 from '@/components/commodity/Commodity04'
import Commodity05 from '@/components/commodity/Commodity05'
import Commodity06 from '@/components/commodity/Commodity06'
import Publish from '@/components/NeedPublish'
import Publish01 from '@/components/publish/Publish01'
import Publish02 from '@/components/publish/Publish02'
import Publish03 from '@/components/publish/Publish03'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index
    },
    {
      path: '/commodity',
      name: 'commodity',
      component: Commodity
    },
    {
      path: '/commodity01',
      name: 'commodity01',
      component: Commodity01
    },
    {
      path: '/commodity02',
      name: 'commodity02',
      component: Commodity02
    },
    {
      path: '/commodity03',
      name: 'commodity03',
      component: Commodity03
    },
    {
      path: '/commodity04',
      name: 'commodity04',
      component: Commodity04
    },
    {
      path: '/commodity05',
      name: 'commodity05',
      component: Commodity05
    },
    {
      path: '/commodity06',
      name: 'commodity06',
      component: Commodity06
    },
    {
      path: '/publish',
      name: 'publish',
      component: Publish
    },
    {
      path: '/publish01',
      name: 'publish01',
      component: Publish01
    },
    {
      path: '/publish02',
      name: 'publish02',
      component: Publish02
    },
    {
      path: '/publish03',
      name: 'publish03',
      component: Publish03
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js